import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { createUrl, get, post } from "../../../network/AxiosInterceptor";
import AdminCreateTripView from "./AdminCreateTripView";
import { mapUserListToInfluencerViewModelList } from "./viewmodels/InfluencerViewModel";
import { useToast } from "../../../components/ui/use-toast";
import { useNavigate } from "react-router-dom";

export const AdminCreateTripContainer = () => {
  const { tripId } = useParams();
  const { toast } = useToast();
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(true);
  const [existingTripDto, setExistingTripDto] = useState(null);
  const [influencers, setInfluencers] = useState([]);
  const [svgList, setSvgList] = useState([]);

  useEffect(() => {
    Promise.all([fetchInfluencers(), fetchTrips(),fetchSvgs()])
      .then(([influencersData, tripsData,svgData]) => {
        setShowLoader(false);
        setInfluencers(influencersData);
        setExistingTripDto(tripsData);
        setSvgList(svgData);
      })
      .catch((error) => {
        setShowLoader(false);
        console.error("One or more requests failed", error);
      });
  }, []);

  const fetchInfluencers = async () => {
    return get(createUrl(`/api/users/all`), {
      params: {
        is_influencer: true,
        offset: 0,
        limit: 100,
      },
    })
      .then((response) => {
        return mapUserListToInfluencerViewModelList(response.data.users);
      })
      .catch(function (error) {
        console.log(error);
        return [];
      });
  };

  const fetchTrips = async () => {
    if (!tripId) {
      return null;
    }
    return get(createUrl(`/api/trips/${tripId}`), {})
      .then((response) => {
        return response.data.trip;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const fetchSvgs = async () => {
    return get(createUrl("/api/svg/getSvgs"))
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("error fetching svgs");
      });
  }

  const onSaveTripClicked = (tripDto, isCloning) => {
    showToastOnSaveClicked(isCloning);
    post(createUrl(`/api/trips/createTrip`), tripDto)
      .then((response) => {
        console.log(response,' -> response')
        if (response.status === "error") {
          showToastOnSaveFailed(isCloning);
          return;
        }
        showToastOnSaveSuccess(isCloning);
        const navUrl = window.location.pathname.split('/').slice(0,-2).join('/');
        setTimeout(() => navigate(`${navUrl}/trips`), 2000);
      })
      .catch(function (error) {
        console.log(error);
        showToastOnSaveFailed(isCloning);
      });
  };

  const showToastOnSaveClicked = (isCloning) => {
    let message = "Creating Trip ...";
    if (existingTripDto) {
      message = isCloning ? "Cloning Trip ..." : "Saving Trip ...";
    }
    toast({
      title: "Exploro",
      description: message,
    });
  };

  const showToastOnSaveSuccess = (isCloning) => {
    let message = "Trip Successfully Created";
    if (existingTripDto) {
      message = isCloning
        ? "Trip Successfully Cloned"
        : "Trip Successfully Saved";
    }
    toast({
      title: "Exploro",
      description: message,
    });
  };

  const showToastOnSaveFailed = (isCloning) => {
    let message = "Trip Creation Failed :(";
    if (existingTripDto) {
      message = isCloning ? "Trip Clone Failed :(" : "Trip Save Failed :(";
    }
    toast({
      title: "Exploro",
      description: message,
      variant: "destructive",
    });
  };

  return (
    <AdminCreateTripView
      showLoader={showLoader}
      existingTripDto={existingTripDto}
      influencers={influencers}
      svgList={svgList}
      onSaveTripClicked={onSaveTripClicked}
    />
  );
};
